import 'waypoints/lib/jquery.waypoints.min';
import { Announcement } from '../communications/announcements/scripts/announcements.entities';
import { plainToClass } from 'class-transformer';


export class SecureHomePage {

    announcements: Announcement[];

    constructor(announcementsJson: any) {

        //document.ready
        $(() => {

            /* Removed until something more up-to-date
            this.announcements = plainToClass(Announcement, <Announcement[]>announcementsJson);

            if (this.announcements && this.announcements.length > 0) {
                this.announcements.forEach((t: Announcement) => {
                    t.Initialize();
                });
                this.announcements.sort((x1: Announcement, x2: Announcement) => x1.SortOrder - x2.SortOrder);

                const announcementsTemplate = document.getElementById('announcement-template') as HTMLTemplateElement;
                const announcementsContainer = document.getElementById('announcement-container');

                this.announcements.forEach((announcement) => {
                    const instance = document.importNode(announcementsTemplate.content, true);

                    const imageElement = instance.querySelector('.announcement-image');
                    imageElement.setAttribute('src', `/images/announcements/${announcement.ImageFile}.jpg`);

                    if (announcement.Link) {
                        const link = document.createElement('a');
                        link.setAttribute('href', announcement.Link);
                        link.setAttribute('target', '_blank');
                        link.innerHTML = announcement.Title;

                        instance.querySelector('.announcement-title').appendChild(link);
                    } else {
                        instance.querySelector('.announcement-title').innerHTML = announcement.Title;
                    }
                    instance.querySelector('.announcement-desc').innerHTML = announcement.Description;
                    instance.querySelector('.announcement-date').innerHTML = announcement.AnnouncementDateFormatted;

                    announcementsContainer.appendChild(instance);
                });
            }
            */

        });

    }

}
